/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useQuery, useLazyQuery } from "@apollo/client";
import { Box } from "@material-ui/core";

import { GET_COURSE_PURCHASES } from "graphql/query/admin";
import Table from "Components/Table/Table";
import { formStyles } from "../listStyles";

const Purchases = ({
  setErrorMsg,
  searchQuery,
  actionPerformed,
  setActionPerformed,
}) => {
  const navigate = useNavigate();
  const classes = formStyles();
  const [purchases, setPurchases] = useState([]);
  const [pageInfo, setPageInfo] = useState("");
  const [page, setPage] = useState(0);

  const buildFilters = () => ({
    ...(searchQuery?.length > 0 && { userFullName: searchQuery }),
  });

  const { data, refetch, error, loading } = useQuery(GET_COURSE_PURCHASES, {
    variables: {
      first: 10,
      orderBy: "createdAt_DESC",
      filters: buildFilters(),
    },
    fetchPolicy: "network-only",
  });

  const [getNextPage, { loading: nextPageLoader }] = useLazyQuery(
    GET_COURSE_PURCHASES
  );
  const [getPrevPage, { loading: prevPageLoader }] = useLazyQuery(
    GET_COURSE_PURCHASES
  );

  const mapList = (edges) => edges.map((c) => ({
    ...c.node,
    userFullName: c.node.user?.fullName,
    courseName: c.node.course?.name,
  }));

  const handleNextPage = async () => {
    if (pageInfo.hasNextPage) {
      const nextPageData = await getNextPage({
        variables: {
          first: 10,
          after: pageInfo.endCursor,
          orderBy: "createdAt_DESC",
          filters: buildFilters(),
        },
        fetchPolicy: "network-only",
      });
      if (nextPageData.data.coursePurchases) {
        setPurchases(mapList(nextPageData.data.coursePurchases.edges));
        setPage(page + 1);
        setPageInfo(nextPageData.data.coursePurchases.pageInfo);
        setErrorMsg("");
      }
    }
  };

  const handlePreviousPage = async () => {
    if (pageInfo.hasPreviousPage) {
      const prevPageData = await getPrevPage({
        variables: {
          last: 10,
          before: pageInfo.startCursor,
          orderBy: "createdAt_DESC",
          filters: buildFilters(),
        },
        fetchPolicy: "network-only",
      });
      if (prevPageData.data.coursePurchases) {
        setPurchases(mapList(prevPageData.data.coursePurchases.edges));
        setPage(page - 1);
        setPageInfo(prevPageData.data.coursePurchases.pageInfo);
        setErrorMsg("");
      }
    }
  };

  const setAllPurchases = () => {
    if (data && data.coursePurchases) {
      setPageInfo(data.coursePurchases.pageInfo);
      setPurchases(mapList(data.coursePurchases.edges));
      setErrorMsg("");
    }
    setPage(0);
  };

  useEffect(() => {
    if (actionPerformed) {
      refetch();
      setActionPerformed(false);
    }
    if (error) {
      setErrorMsg("Error in loading data !");
    }
    setAllPurchases();
  }, [data, actionPerformed, error, searchQuery]);

  const handleUserClick = (row) => {
    if (row?.userId) {
      navigate("/admin/user/view-user", { state: { id: row.userId } });
    }
  };

  const handleCourseClick = (row) => {
    if (row?.courseId) {
      navigate("/admin/course/view-course", { state: { id: row.courseId } });
    }
  };

  const TABLE_HEAD = [
    { id: "id", flag: "id", label: "No.", alignRight: false },
    {
      id: "userFullName",
      flag: "userFullName",
      label: "User",
      clickable: true,
      callback: { onCellClick: handleUserClick },
      alignRight: false,
    },
    {
      id: "courseName",
      flag: "courseName",
      label: "Course",
      clickable: true,
      callback: { onCellClick: handleCourseClick },
      alignRight: false,
    },
    { id: "price", flag: "price", label: "Price", alignRight: false },
    { id: "createdAt", flag: "createdAt", label: "Created At", alignRight: false },
  ];

  return (
    <Box className={classes.mainContainer}>
      <Table
        error={error}
        USERLIST={purchases}
        page={page}
        handleNextPage={handleNextPage}
        handlePreviousPage={handlePreviousPage}
        TABLE_HEAD={TABLE_HEAD}
        pageInfo={pageInfo}
        loading={loading || nextPageLoader || prevPageLoader}
      />
    </Box>
  );
};

export default Purchases;
